import React from 'react';
import ChannelDetailPage from './ChannelDetailPage';

const ChannelsShopifyPage: React.FC = () => {
  return <ChannelDetailPage channelName="shopify" />;
};

export default ChannelsShopifyPage;
